import React from 'react';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
export function AudienceSection() {
  const forYou = ['Profesionales de 30+ años que viven solos y sienten que el sueldo se les va en comida.', 'Personas que teletrabajan y terminan pidiendo delivery por falta de una despensa inteligente.', 'Hombres y mujeres que quieren ganarle a la inflación en Chile con datos reales, no consejos genéricos.'];
  const notForYou = ['Familias de 4 o más personas (este sistema es específico para hogares unipersonales).', 'Personas que no están dispuestas a cambiar de marca o visitar un mayorista una vez al mes.', 'Gente que busca recetas de cocina (esto es un manual de optimización financiera).'];
  return <section className="w-full bg-[#f1f5f9] py-16 px-4" data-id="element-15">
      <div className="max-w-6xl mx-auto" data-id="element-16">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-17">
          <div className="bg-white rounded-lg p-8 shadow-md border-l-4 border-[#22c55e]" data-id="element-18">
            <h3 className="text-2xl font-bold text-[#1a2332] mb-6" data-id="element-19">
              Esto ES para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-20">
              {forYou.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-21">
                  <CheckCircleIcon className="w-6 h-6 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-22" />
                  <span className="text-gray-700 leading-relaxed" data-id="element-23">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="bg-white rounded-lg p-8 shadow-md border-l-4 border-[#ef4444]" data-id="element-24">
            <h3 className="text-2xl font-bold text-[#1a2332] mb-6" data-id="element-25">
              Esto NO es para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-26">
              {notForYou.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-27">
                  <XCircleIcon className="w-6 h-6 text-[#ef4444] flex-shrink-0 mt-0.5" data-id="element-28" />
                  <span className="text-gray-700 leading-relaxed" data-id="element-29">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}